/* import __COLOCATED_TEMPLATE__ from './monitor-filter.hbs'; */
/* RESPONSIBLE TEAM: team-fin-qa */

import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type InboxSidebarService from 'embercom/services/inbox-sidebar-service';
import type { Monitor } from 'embercom/services/monitors-api';

interface Signature {
  Args: {
    monitorId?: string;
    isAnyMonitor?: boolean;
    onSelectMonitor: (monitorId: string | null) => void;
    showRemoveButton?: boolean;
    onRemove?: (event?: Event) => void;
  };
  Element: HTMLElement;
}

interface MonitorDropdownItem {
  text: string;
  value: string | null;
  isSelected: boolean;
  component: string;
}

export default class MonitorFilter extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare inboxSidebarService: InboxSidebarService;
  @tracked isHovered = false;

  get label() {
    this.intl.primaryLocale;

    if (this.args.isAnyMonitor) {
      return this.intl.t('inbox.search.filters.more-filters.monitor-any');
    }

    if (!this.args.monitorId) {
      return this.intl.t('inbox.search.filters.more-filters.monitor');
    }

    let monitor = this.monitors.find((m) => m.id === this.args.monitorId);
    return monitor?.name || this.intl.t('inbox.search.filters.more-filters.monitor');
  }

  get monitors(): Monitor[] {
    return this.inboxSidebarService.monitors;
  }

  get items() {
    let anyItem: MonitorDropdownItem = {
      text: this.intl.t('inbox.search.filters.more-filters.monitor-any'),
      value: 'any',
      isSelected: !!this.args.isAnyMonitor,
      component: 'inbox2/left-nav/conversation-list/filters-item',
    };

    let monitorItems: MonitorDropdownItem[] = this.monitors.map((monitor) => ({
      text: monitor.name,
      value: monitor.id,
      isSelected: monitor.id === this.args.monitorId,
      component: 'inbox2/left-nav/conversation-list/filters-item',
    }));

    let groups = [{ items: [anyItem] }, { items: monitorItems }];

    if (this.args.monitorId || this.args.isAnyMonitor) {
      groups.push({
        items: [
          {
            text: this.intl.t('inbox.search.filters.general.clear'),
            value: null,
            isSelected: false,
            component: 'inbox2/left-nav/conversation-list/filters-item',
          },
        ],
      });
    }

    return groups;
  }

  @action
  onSelectMonitor(selectedValue: string | null) {
    this.args.onSelectMonitor(selectedValue);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::MonitorFilter': typeof MonitorFilter;
    'inbox2/search/monitor-filter': typeof MonitorFilter;
  }
}
